import { render } from "./list.vue?vue&type=template&id=e45ecd78&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"

import "./list.vue?vue&type=style&index=0&id=e45ecd78&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e45ecd78"

export default script